import {Checkbox} from '@/components/commons/checkbox/ChekBox'
import {AgendaSidebarDottedDivider} from '@/features/agenda/components/agenda-sidebar-dotted-divider/AgendaSidebarDottedDivider'
import {useAgendaSearchHandlers} from '@/features/agenda/hooks/useAgendaSearchHandlers'
import {useAgendaSearchParams} from '@/features/agenda/hooks/useAgendaSearchParams'
import {useTranslation} from '@/translations/i18n'

export const AgendaDomiciliaryCheckbox = () => {
    const {t} = useTranslation()
    const {searchParams} = useAgendaSearchParams()
    const {handleHideDomiciliary} = useAgendaSearchHandlers()
    return (
        <>
            <AgendaSidebarDottedDivider />
            <Checkbox
                id="hide-domiciliary-checkbox"
                label={t('commons:hide_domiciliary')}
                checked={!!searchParams.hideDomiciliary}
                onChange={e => handleHideDomiciliary(e.target.checked)}
            />
        </>
    )
}
